import { render, staticRenderFns } from "./return.vue?vue&type=template&id=5ca841be&scoped=true&"
import script from "./return.vue?vue&type=script&lang=js&"
export * from "./return.vue?vue&type=script&lang=js&"
import style0 from "./return.vue?vue&type=style&index=0&id=5ca841be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca841be",
  null
  
)

export default component.exports